import { c as _c } from "react/compiler-runtime";
import { useTheme } from 'styled-components';
import { CodeBlock } from '../../scenes/DashboardScene/Event/CodeBlock';
import Button from '../base/Button';
import Text from '../base/Text';
import { Div } from '../helpers/StyledUtils';
import { CollapsableDataSection } from './CollapsableDataSection';
import Divider from '../base/Divider';
import useLocalStorage from '../../hooks/useLocalStorage';
import Link from '../base/Link';
export const QueryCollapsibleSection: React.FC<{
  query: string;
  parsed_query: Record<string, any>;
  embedded: boolean;
  context_menu?: boolean;
}> = t0 => {
  const $ = _c(45);
  const {
    query,
    parsed_query,
    embedded,
    context_menu: t1
  } = t0;
  const context_menu = t1 === undefined ? false : t1;
  const [collapsed, setCollapsed] = useLocalStorage("prefs:data:query:collapsed", true);
  const theme = useTheme();
  const t2 = embedded ? 100 : undefined;
  let t3;
  if ($[0] !== embedded) {
    t3 = embedded ? {
      x: 6
    } : undefined;
    $[0] = embedded;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      filter_field_key: "request_query",
      table_column_prefix: "query"
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = embedded ? 0 : collapsed ? 0 : 8;
  let t6;
  if ($[3] !== t5) {
    t6 = {
      b: t5
    };
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = embedded && !collapsed ? theme.colors.surface.base.variant_surface_3 : undefined;
  let t8;
  if ($[5] !== t7) {
    t8 = {
      backgroundColor: t7
    };
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== collapsed || $[8] !== setCollapsed) {
    t9 = <Text semi={true} onClick={() => setCollapsed(!collapsed)}>Query</Text>;
    $[7] = collapsed;
    $[8] = setCollapsed;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      align: "center",
      gap: 2
    };
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== collapsed || $[12] !== embedded) {
    t11 = embedded && !collapsed && <><CodeBlock.DropdownDisplayType ghost={true} /><CodeBlock.ButtonCopy ghost={true} /></>;
    $[11] = collapsed;
    $[12] = embedded;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== collapsed || $[15] !== embedded || $[16] !== setCollapsed) {
    t12 = embedded ? <Button ghost={true} icon={collapsed ? "chevron_down" : "chevron_up"} onClick={() => setCollapsed(!collapsed)} /> : <Link neutral={true} icon={collapsed ? "chevron_down" : "chevron_up"} onClick={() => setCollapsed(!collapsed)} />;
    $[14] = collapsed;
    $[15] = embedded;
    $[16] = setCollapsed;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t11 || $[19] !== t12) {
    t13 = <Div flex={t10}>{t11}{t12}</Div>;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== collapsed || $[22] !== embedded || $[23] !== t13 || $[24] !== t9) {
    t14 = <CollapsableDataSection embedded={embedded} collapsed={collapsed} z_index={2}>{t9}{t13}</CollapsableDataSection>;
    $[21] = collapsed;
    $[22] = embedded;
    $[23] = t13;
    $[24] = t9;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== collapsed || $[27] !== embedded) {
    t15 = !collapsed && <Div flex={{
      direction: "column",
      gap: embedded ? 0 : 4
    }}><Div flex={{
        gap: 3
      }} m={embedded ? {
        x: 6
      } : undefined}><CodeBlock.Search m={embedded ? {
          b: 4
        } : undefined} />{!embedded && <><CodeBlock.DropdownDisplayType /><CodeBlock.ButtonCopy /></>}</Div><CodeBlock.Code /></Div>;
    $[26] = collapsed;
    $[27] = embedded;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== embedded) {
    t16 = embedded && <Divider />;
    $[29] = embedded;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t14 || $[32] !== t15 || $[33] !== t16 || $[34] !== t6 || $[35] !== t8) {
    t17 = <Div m={t6} style={t8}>{t14}{t15}{t16}</Div>;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
    $[34] = t6;
    $[35] = t8;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== context_menu || $[38] !== embedded || $[39] !== parsed_query || $[40] !== query || $[41] !== t17 || $[42] !== t2 || $[43] !== t3) {
    t18 = <CodeBlock.Provider text={parsed_query} raw={query} embedded={embedded} filters_width={t2} filters_margin={t3} context_menu={context_menu} context_menu_config={t4}>{t17}</CodeBlock.Provider>;
    $[37] = context_menu;
    $[38] = embedded;
    $[39] = parsed_query;
    $[40] = query;
    $[41] = t17;
    $[42] = t2;
    $[43] = t3;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  return t18;
};